import { useSelector } from 'react-redux';
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UILink from 'UIComponents/link/UILink';
import { getTierI18nKey } from 'marketplace-ui-common/utils/i18n';
// @ts-expect-error untyped dependency
import { getIsCustomer } from '../../../selectors/auth';
// @ts-expect-error untyped dependency
import { getPricingUrl } from '../../../utils/urls';
// @ts-expect-error untyped dependency
import CompatibilityIcon from '../../common/CompatibilityIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const FeatureCardCompatibility = ({
  onTrackInteraction,
  requiredPlan
}) => {
  const isCustomer = useSelector(getIsCustomer);
  const requiredPlanHub = requiredPlan && requiredPlan.split('_')[0];
  return /*#__PURE__*/_jsx(UIMediaObject, {
    align: "start",
    itemLeft: /*#__PURE__*/_jsx(CompatibilityIcon, {
      compatible: !requiredPlan
    }),
    spacing: "extra-small",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `appMarketplace.detail.overview.integrationFeatures.${requiredPlan ? 'notCompatible_jsx' : 'compatible_jsx'}`,
      options: {
        planName: requiredPlan ? I18n.text(getTierI18nKey(requiredPlan)) : '',
        linkProps: {
          external: true,
          href: getPricingUrl(isCustomer, requiredPlanHub),
          onClick: () => onTrackInteraction('click feature required plan pricing link', 'overview', requiredPlanHub)
        }
      },
      elements: {
        Bold: 'b',
        Link: UILink
      }
    })
  });
};